import React, { useCallback } from 'react'
import styled, { x } from '@xstyled/styled-components'
import { Field, FormikProps, FormikValues } from 'formik'
import getOr from 'lodash/fp/getOr'
import Button from '@mailstep/design-system/ui/Elements/Button'
import InputField from '@components/forms/components/InputField'
import { FieldLabel } from '@mailstep/design-system/ui/Elements/Label'

type Props = {
  remove: Function
  push: Function
  name: string
  form: FormikProps<FormikValues>
  disabled?: boolean
  icon?: string
  label?: React.ReactNode
}

const InputWrap = styled.div`
  margin: 0 2 0 0;
  width: 38%;
`

const StyledWrap = styled.div`
  display: flex;
  flex-flow: wrap;
`

const RefNumbersField = ({ remove, push, label, name, form, disabled, icon }: Props): JSX.Element => {
  const referenceNumbers: string[] = getOr([], name, form?.values)

  const handleRemoveClick = useCallback(
    (index: number): void => {
      if (referenceNumbers.length > 0) {
        if (remove) remove(index)
        form.setTouched({ [name]: true })
      }
    },
    [form, name, referenceNumbers.length, remove],
  )

  const addAnother = useCallback(() => push(''), [push])

  return (
    <x.div mb="16px" w="100%">
      {label && <FieldLabel htmlFor={name}>{label}</FieldLabel>}

      <StyledWrap>
        {referenceNumbers.map((refNumber: string, index: number) => (
          <InputWrap key={`${index}`} size={5}>
            <Field
              component={InputField}
              value={refNumber}
              name={`${name}[${index}]`}
              disabled={disabled}
              icon={icon}
              spaceAround
              id={index as unknown as string}
              onClear={() => (!disabled ? handleRemoveClick(index) : undefined)}
              alwaysShowClear
            />
          </InputWrap>
        ))}
        <x.div mt="2px">
          <Button type="button" onClick={addAnother} icon="plus" appearance="ghost" disabled={disabled}></Button>
        </x.div>
      </StyledWrap>
    </x.div>
  )
}

export default RefNumbersField
